import { isDevelopment, isTest } from 'config/environment';

export const C300_URL = isDevelopment()
  ? 'https://test-01-lk.eis24.me/#/'
  : isTest()
    ? `${window.location.origin.replace('dispatcher', 'lk')}/#/`
    : 'https://lk.eis24.me/#/';
